import {joinURL} from "ufo";
import type {Pages_V1} from "#magnolia-layer/types/api";
import {useMagnoliaContext} from "#magnolia-layer/composables/use-magnolia-context";

export const usePagesByIds = async (
    ids: string[],
): Promise<Pages_V1 | undefined> => {
  if (ids.length === 0) {
    return undefined;
  }

  const runtimeConfig = useRuntimeConfig();
  const pageIds = ids.join("%7c");

  const baseURL: string = import.meta.server ? runtimeConfig.mgnl.host : runtimeConfig.public.mgnl.host;
  const magnoliaContext = useMagnoliaContext();

  // We have to build our own url as using query will cause duplicate encoding regardless of useMagnoliaFetch or native useFetch causing %7C to be transformed back in to |
  const apiUrl: string = joinURL(baseURL, runtimeConfig.public.mgnl.apiPages, `?@jcr:uuid=${pageIds}&lang=${magnoliaContext.searchParams?.lang}`);

  const {data: content, error} = await useFetch<Pages_V1>(apiUrl);
  if (content.value) {
    return content.value;
  }

  return undefined;
};